<mat-card-header>
	<mat-card-title>
		{{studentName}} {{regions}} <span class="danger h5">{{merged}}</span> <span
			class="danger h5">{{terminated}}</span>
		<span class="margin-left-sm" *ngIf="isMerged || merged"><view-children-merge-tree-btn [studentId]="studentId"
				[studentMsdNumber]="msdNumber"></view-children-merge-tree-btn></span>
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon>
	</mat-card-title>
</mat-card-header>

<mat-card-content>
	<div *ngIf="!isLoading">

		<div class="row">
			<div class="col-lg-6">
				<view-child-demographic [studentId]="studentId"></view-child-demographic>
			</div>
			<div class="col-lg-6">
				<view-child-address-info></view-child-address-info>
			</div>
		</div>


		<view-child-enrollment [studentId]="studentId"></view-child-enrollment>

		<view-child-eligibility-status [studentId]="studentId"></view-child-eligibility-status>

		<view-child-move-history [studentId]="studentId"></view-child-move-history>

		<view-child-service-participation [studentId]="studentId"></view-child-service-participation>
	</div>
</mat-card-content>